import { useMemo } from 'react'

const DOCUMENTATION_TYPES = [
  'Undergraduate Final Year Project',
  "Master's Thesis",
  'PhD Thesis',
  'PGD Final Project'
]

export function useTopicGenerationStatus (projects, documentations) {
  const topicStatusById = useMemo(() => {
    const map = {}
    const docsByProject = {}
    ;(documentations || []).forEach((d) => {
      const pid = d.project?._id || d.project
      if (!pid) return
      const key = String(pid)
      if (!docsByProject[key]) docsByProject[key] = []
      docsByProject[key].push(d)
    })

    ;(projects || []).forEach((p) => {
      const topicId = p.topic?._id || p.topic
      if (!topicId) return
      const key = String(topicId)
      if (!map[key]) {
        map[key] = { projects: [], generationIncomplete: false, hasCompleteDoc: false }
      }
      const docs = docsByProject[String(p._id)] || []
      const generationIncomplete = docs.some(
        (d) => d.generationStatus === 'IN_PROGRESS' || d.generationStatus === 'FAILED'
      )
      const hasCompleteDoc = docs.some((d) => d.generationStatus === 'COMPLETE')
      map[key].projects.push({
        projectId: p._id,
        documentationType: p.documentationType,
        generationIncomplete,
        hasCompleteDoc
      })
      if (generationIncomplete) map[key].generationIncomplete = true
      if (hasCompleteDoc) map[key].hasCompleteDoc = true
    })

    return map
  }, [projects, documentations])

  const shouldHideGenerate = (topicId) => {
    const status = topicStatusById[String(topicId)]
    if (!status) return false
    if (status.generationIncomplete) return true
    const usedTypes = new Set(status.projects.map((p) => p.documentationType).filter(Boolean))
    const allTypesUsed = DOCUMENTATION_TYPES.every((t) => usedTypes.has(t))
    return allTypesUsed
  }

  const getTopicStatusLabel = (topicId) => {
    const status = topicStatusById[String(topicId)]
    if (!status || status.projects.length === 0) return null
    if (status.generationIncomplete) return 'Generation in progress'
    if (status.hasCompleteDoc) return 'Documentation generated'
    return 'Project created'
  }

  const getProjectLink = (topicId) => {
    const status = topicStatusById[String(topicId)]
    if (!status?.projects?.length) return null
    const incomplete = status.projects.find((p) => p.generationIncomplete)
    if (incomplete) return incomplete.projectId
    return status.projects[status.projects.length - 1].projectId
  }

  return { topicStatusById, shouldHideGenerate, getTopicStatusLabel, getProjectLink }
}
